import styled from "styled-components";

export const CelebrityArtStyled = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;
